import GlowEffect from "../common/GlowEffect";
import { useAboutData } from "../../hooks/useAboutData";

const TeamSection = () => {
  const { data } = useAboutData();

  return (
    <div className="relative px-5 sm:px-10 md:px-16">
      <GlowEffect />
      <h1 className="text-5xl md:text-6xl font-medium text-center my-10">{data.team.title}</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-20 justify-items-center items-start px-10">
        {data.team.members.map((member, index) => (
          <div key={index} className="w-full max-w-[380px]">
            <div className="w-full aspect-[4/5] overflow-hidden rounded-2xl mb-5">
              <img
                className="w-full h-full object-cover object-top hover:scale-105 transition-all duration-300"
                src={member.image}
                alt={member.name}
              />
            </div>
            <h2 className="text-xl md:text-3xl font-bold">{member.name}</h2>
            <h2 className="text-xl md:text-3xl font-light text-wrap">{member.title}</h2>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamSection;
